import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { FontText } from './FontText';

interface PrimaryButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  loading?: boolean;
  size?: 'small' | 'medium' | 'large';
}

export const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  children,
  loading = false,
  size = 'medium',
  disabled,
  style,
  ...props
}) => {
  const { theme } = useTheme();

  const buttonStyles: React.CSSProperties = {
    backgroundColor: theme.colors.accent,
    color: theme.colors.white,
    border: 'none',
    borderRadius: 8,
    cursor: disabled || loading ? 'not-allowed' : 'pointer',
    transition: 'all 0.2s ease',
    opacity: disabled || loading ? 0.6 : 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    padding: '10px 20px',
    ...style,
  };

  return (
    <button style={buttonStyles} disabled={disabled || loading} {...props}>
      {loading && (
        <div
          style={{
            width: 16,
            height: 16,
            border: '2px solid transparent',
            borderTop: '2px solid currentColor',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
          }}
        />
      )}
      <FontText isContent>{children}</FontText>
    </button>
  );
};
